import React from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import RadioStationCard from "../shared/RadioStationCard";

function StationMightLikeCoursel({ stations }: any) {
  return (
    <div>
      {/* top section */}
      <div className="mt-10 mb-8 w-[98%]">
        <div>
          <h1 className="text-2xl font-medium text-white lg:text-2xl md:text-2xl">
            Stations you might like
          </h1>
        </div>
      </div>
      {/* coursel */}
      <div className="">
        <Swiper
          slidesPerView={5}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            650: {
              slidesPerView: 2,
            },
            1000: {
              slidesPerView: 3,
            },
            1100: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
            1500: {
              slidesPerView: 5,
            },
            1600: {
              slidesPerView: 6,
            },
          }}
          modules={[Pagination]}
          className="mt-4 mb-5 mySwiper"
        >
          {stations?.map((station: any, i: number) => (
            <div key={i}>
              <SwiperSlide className="">
                <RadioStationCard station={station} />
              </SwiperSlide>
            </div>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default StationMightLikeCoursel;
